import type { AccompanyingVisitorState } from '../types';

export const initialState: AccompanyingVisitorState = {
  patientInfo: {
    institutionCode: undefined,
    institutionName: undefined,
    nric: undefined,
  },
};
